var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qrcode",staticClass:"qrcode",attrs:{"id":_vm.qrcodeId}},[_vm._v("二维码图片")])
}
var staticRenderFns = []

export { render, staticRenderFns }